/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/logo/partner/partner_styles';



/* ========== ~~~~~~~~~~ EMBED : PARTNER LOGO ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const PartnerLogo = (props) => {
    function isValidURL() {
        const elSettings = props.selectedEmbedStatus.selectedEmbedData.partnerLogo;
        return elSettings.url === undefined || elSettings.url === null || elSettings.url === '' ? false : true;
    }
    return (
        <a className={`partnerlogo ${props.classes.partnerlogo} clickable-${isValidURL()}`} href={props.selectedEmbedStatus.selectedEmbedData.partnerLogo.url} target="_blank" rel="noopener noreferrer" style={props.selectedEmbedStatus.selectedEmbedData.showPartnerLogo ? { backgroundImage: `url(${props.selectedEmbedStatus.selectedEmbedData.partnerLogo.src})` } : { display: 'none' }}><span className={`accessibility`}>Partner Logo</span></a>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PartnerLogo);